<div class="messages-container pending">
  <div class="messages" (appDomChange)="onDomChange($event)">
    @for (message of pendingMessages.messages; track message; let i = $index) {
      <div [id]="'msg-' + message.id" class="message-bubble me" (click)="retrySendMessage.emit(message.id)">
        <div class="message-content">
          @if (i === 0) {
            <div class="author">{{ pendingMessages.name }}</div>
          }
          <div class="box">
            <div class="inner-box">
              <app-dynamic-content class="chat-message" [content]="message.content"></app-dynamic-content>
              @if (message.status === 'in-progress') {
                <div class="in-progress">
                  <ion-spinner></ion-spinner>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      @if (message.canRetry) {
        <div class="error">Unable to send. Please tap the message to try again.</div>
      }
    }
  </div>
</div>
